import React from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { WhyDiagnosticMatters } from './components/WhyDiagnosticMatters';
import { ProblemKeepsReturning } from './components/ProblemKeepsReturning';
import { DiagnosticProcess } from './components/DiagnosticProcess';
import { TransparentInspection } from './components/TransparentInspection';
import { WhyLancer } from './components/WhyLancer';
import { SocialProof } from './components/SocialProof';
import { ServiceConvenience } from './components/ServiceConvenience';
import { FullServiceShop } from './components/FullServiceShop';
import { FinalCTA } from './components/FinalCTA';
import { LocationMap } from './components/LocationMap';
export function App() {
  return <div className="min-h-screen bg-brand-light font-sans selection:bg-brand-accent selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustBar data-id="element-4" />
        <ProblemKeepsReturning data-id="element-5" />
        <WhyDiagnosticMatters data-id="element-6" />
        <DiagnosticProcess data-id="element-7" />
        <TransparentInspection data-id="element-8" />
        <WhyLancer data-id="element-9" />
        <SocialProof data-id="element-10" />
        <ServiceConvenience data-id="element-11" />
        <FullServiceShop data-id="element-12" />
        <FinalCTA data-id="element-13" />
        <LocationMap data-id="element-14" />
      </main>

      <footer className="bg-brand-dark text-gray-500 py-8 text-center text-sm border-t border-gray-800" data-id="element-15">
        <div className="max-w-6xl mx-auto px-4" data-id="element-16">
          <a href="https://www.lancerservice.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-brand-accent transition-colors font-semibold" data-id="element-17">
            www.lancerservice.com
          </a>
          <p className="text-gray-400 font-medium mt-3" data-id="element-18">
            Mon – Fri 7:00am – 5:00pm · 270 E 8th St, St Paul, MN 55101
          </p>
          <p className="mt-3" data-id="element-19">
            © {new Date().getFullYear()} Lancer Service. All rights reserved.
          </p>
          <p className="mt-1" data-id="element-20">Independent Auto Repair · St. Paul, MN</p>
        </div>
      </footer>
    </div>;
}